import { ChangeDetectionStrategy, Component, DestroyRef, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder } from '@angular/forms';
import { CustomerSpaceService } from '@core/customer-space/customer-space.service';
import { ReportService } from '@core/report/report.service';
import * as CoreActions from '@core/core.actions';
import { select, Store } from '@ngrx/store';
import { FileUploadDialogComponent } from '@platform/components/file-upload-widget/file-upload/file-upload-dialog/file-upload-dialog.component';
import { DialogV2Service } from '@platform/dialog/dialog-v2.service';
import { selectPortalConfig } from '@platform/platform.selectors';
import { PortalConfig } from '@platform/platform.state';
import { ToastService } from '@platform/toast/toast.service';
import { RootState } from '@root/app.state';
import { AdminActionItemComponent } from '../ui/admin-action-item.component';
import { AdminPageSectionComponent } from '../ui/admin-page-section.component';
import { ButtonIndicatorUploadComponent } from '../ui/button-indicator-upload.component';

@Component({
  selector: 'app-create-customers-section',
  imports: [AdminPageSectionComponent, AdminActionItemComponent, ButtonIndicatorUploadComponent],
  templateUrl: './create-customers-section.component.html',
  styleUrl: './create-customers-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateCustomersSectionComponent {
  public readonly portalConfig: Signal<PortalConfig | null | undefined>;

  constructor(
    private store$: Store<RootState>,
    private destroyRef: DestroyRef,
    private reportService: ReportService,
    private toastService: ToastService,
    private formBuilder: FormBuilder,
    private dialogService: DialogV2Service,
    private custService: CustomerSpaceService,
  ) {
    // this.latestTemplateUpdates = toSignal(store$.pipe(select(selectTemplateActualisation), filterSucceededResource()));

    // this.extractPending = toSignal(
    //   store$.pipe(
    //     select(selectSharepointTemplateExtraction),
    //     map((state) => state.status === ResourceStatuses.PENDING),
    //   ),
    //   { initialValue: false },
    // );

    this.portalConfig = toSignal(store$.pipe(select(selectPortalConfig)));
  }

  openFileUploadDialog() {
    const portalConfig = this.portalConfig();
    if (!portalConfig) {
      return;
    }

    this.dialogService
      .open(FileUploadDialogComponent, {
        data: {
          multiple: false,
          invalidCharacters: portalConfig.invalidFileAndFolderNameCharacters,
          allowedFileFormats: ['xlsx'],
        },
      })
      .afterClosed()
      .subscribe((value) => {
        if (value) {
          this.toastService.showPendingToast('admin.batch-creation.upload-success-message');
          this.store$.dispatch(
            CoreActions.uploadBatchCreationFile({
              files: value.files,
            }),
          );
        }
      });
  }
}
